import { useRef } from 'react';

export interface IMutableRef<T> {
    current: T;
}

export function createMutableRef<T>(): IMutableRef<T> {
    return { current: null } as any;
}

export function useChooseRef<T = HTMLElement>(ref?: React.RefObject<T>) {
    const defaultRef = useRef(null);
    return ref ?? defaultRef;
}
